module.exports = {
    title: '河北省0-6岁儿童视力监测系统',

    /**
     * @type {string}
     * @description 接口基础地址http://3502.wangshouxin.cn 'http://dev.3502.wangshouxin.cn'
     */
    apiBaseUrl: process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BASE_HOST ? process.env.VUE_APP_BASE_HOST : 'http://shishaiadmin.cn/', //'https://dev.jinshiguangyiliao.com/  // 'http://shishaiadmin.cn/'

    /**
     * @type {string}
     * @description 上传接口地址
     */
    uploadUrl: '/admin/Attachment/upload',
    uploadNoTokenUrl: '/admin/Attachment/uploadNoToken',

    /**
     * @type {boolean} true | false
     * @description Whether show the settings right-panel
     */
    showSettings: false,

    /**
     * @type {boolean} true | false
     * @description Whether need tagsView
     */
    tagsView: true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: false,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    sidebarLogo: true,

    /**
     * @type {boolean} true | false
     * @description Whether show menu title in sidebar isCollapse
     */
    showText: true,

    /**
     * @type {string | array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: 'production'
}